// RFC 2822 Regex taken from here https://gist.github.com/gregseth/5582254
export const isValidEmail = email => {
  return !!String(email)
    .toLowerCase()
    .match(
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
    );
};
